import { createApi } from '@reduxjs/toolkit/query/react';
import { createTimelyBaseQuery } from 'api/core/base';
import type { SyncStatusesResponse, SyncStatusSummary } from 'types/syncStatus';

/**
 * RTK Query API slice for Timely sync statuses.
 * Uses Timely's standard authentication via createTimelyBaseQuery.
 */
export const syncStatusApi = createApi({
  reducerPath: 'syncStatusApi',
  baseQuery: createTimelyBaseQuery(),
  tagTypes: ['SyncStatus', 'SyncStatusSummary'],
  endpoints: build => ({
    getSyncStatuses: build.query<SyncStatusesResponse, { hourIds: number[] }>({
      query: ({ hourIds }) => ({
        url: 'sync_statuses',
        params: { hour_ids: hourIds.join(',') },
      }),
      providesTags: (result, error, { hourIds }) =>
        hourIds.map(id => ({ type: 'SyncStatus' as const, id })),
    }),
    getSyncStatusSummary: build.query<SyncStatusSummary, { toolId: string }>({
      query: ({ toolId }) => ({
        url: 'sync_statuses/summary',
        params: { tool_id: toolId },
      }),
      providesTags: (result, error, { toolId }) => [{ type: 'SyncStatusSummary', id: toolId }],
    }),
  }),
});

export const { useGetSyncStatusesQuery, useGetSyncStatusSummaryQuery } = syncStatusApi;
